import React from 'react';
import { Phone, Mail, Instagram, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  const { contact, company } = mockData;

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">{company.name}</h3>
            <p className="text-gray-300 mb-4">{company.tagline}</p>
            <p className="text-gray-400 text-sm">{company.established}</p>
            <div className="flex items-center mt-4 text-gray-300">
              <MapPin className="h-4 w-4 mr-2" />
              <span>{company.location}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition-colors">
                  Our Services
                </a>
              </li>
              <li>
                <a href="#catalog" className="text-gray-300 hover:text-white transition-colors">
                  Product Catalog
                </a>
              </li>
              <li>
                <a href="#industries" className="text-gray-300 hover:text-white transition-colors">
                  Industries We Serve
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-white transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-300">
                <Phone className="h-4 w-4 mr-3 flex-shrink-0" />
                <a href={`tel:${contact.phone}`} className="hover:text-white transition-colors">
                  {contact.phone}
                </a>
              </li>
              <li className="flex items-center text-gray-300">
                <Mail className="h-4 w-4 mr-3 flex-shrink-0" />
                <a href={`mailto:${contact.email}`} className="hover:text-white transition-colors">
                  {contact.email}
                </a>
              </li>
              <li className="flex items-center text-gray-300">
                <Instagram className="h-4 w-4 mr-3 flex-shrink-0" />
                <a
                  href={`https://instagram.com/${contact.instagram.replace('@', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  {contact.instagram}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} {company.name}. All rights reserved.</p>
          <p className="mt-2">A part of & powered by <span className="text-white font-semibold">ALF OFFICE SUPPLIES COMPANY</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
